import { Field, Layout } from "@introist/react-foundation/v2";
import { TextInput } from "../../../components/atoms";
import { ConnectFormProps } from "../views/DataSourceConnectionSetupView/steps/DataSourceConnectionForm";
type GreenhouseConfig = {
  apiKey: string;
};
export const GreenhouseConnectForm = ({ values, onChange }: ConnectFormProps) => {
  const credentials = (values?.credentials as GreenhouseConfig) ?? {
    apiKey: ""
  };

  return (
    <Layout.Group vertical gap="xLarge">
      <TextInput label="Name" value={values?.name} onChange={name => onChange({ name })} />
      <Field title="Api key">
        <TextInput
          placeholder="Api key"
          value={credentials.apiKey}
          type="password"
          onChange={apiKey =>
            onChange({
              credentials: { ...credentials, apiKey }
            })
          }
        />
      </Field>
    </Layout.Group>
  );
};
